import $ from 'jquery'
import {Core} from './core'

export let selectorClasses = {
  main: 'selector',
  default: 'default',
  stylised: 'selector-stylised',
  multiple: 'selector-multiple',
  active: 'selector-active',
  selected: 'selector-selected',
  itemsWrapper: 'selector-items-wrapper',
  items: 'selector-items',
  option: 'selector-option',
  optionGroup: 'selector-option-group',
  optionHover: 'selector-option-hover',
  optionSelected: 'selector-option-selected',
  country: {
    main: 'selector-country',
    inputWrapper: 'selector-country-input-wrapper',
    input: 'selector-country-input',
  }
}

let hasCurrentFocusClickSelector = false

export function initSelector() {
  if (!Core.isAdmin()) {
    initEventSelector()

    $('body').on('DOMSubtreeModified', findAndGenerateSelectorsStyle)

    let counter = 0

    let timeout = setInterval(() => {
      if (counter > 5) {
        clearInterval(timeout)
      }
      counter++
      findAndGenerateSelectorsStyle()
    }, 400);
  }
}

/**
 *
 */
export function findAndGenerateSelectorsStyle() {
  $('select').each(actionSelect)
}

export function initEventSelector() {
  let $body = $('body')

  /* On focus select */
  $body.on('focus', 'select', handleClickSelector)

  /* Add event click item */
  $body.on('click', `.${selectorClasses.option}`, handleClickSelectorOption)

  /* On keydown arrow down/up fake select opened */
  $body.on('keydown', handleKeydownSelector)

  /* On click fake select */
  $body.on('focus click', `.${selectorClasses.selected}`, handleClickSelector)

  /* Add event change input country */
  $body.on('keyup', `.${selectorClasses.country.input}`, handleInputCountry)

  /* Add event click item */
  $(document).on('click', handleClickDocument)
}

/**
 * Action pour boucler sur la stylisation des selectors (transfert de JS à jQuery)
 *
 * @param index
 * @param select
 */
export function actionSelect(index, select) {
  stylisedSelector($(select))
}

/**
 * Génère le fake selector
 *
 * @param select
 */
export function stylisedSelector(select) {
  if (Core.isAdmin()) return

  let $select = $(select)

  if (!$select.hasClass(selectorClasses.stylised)) {
    $select.addClass(selectorClasses.stylised)

    $select.wrap(`<div class="${selectorClasses.main}"></div>`)

    let $parentSelect = $select.parent()
    let isMultiple = $select.prop('multiple')

    if (isMultiple) {
      $parentSelect.addClass(selectorClasses.multiple)
    }

    $parentSelect.append(`<div class="${selectorClasses.selected}" tabindex="0">${$select.find('option').first().text()}</div>`)
    $parentSelect.append(`<div class="${selectorClasses.itemsWrapper}"><div class="${selectorClasses.items}"></div></div>`)

    let $selectSelected = $parentSelect.find(`.${selectorClasses.selected}`)
    let $selectItems = $parentSelect.find(`.${selectorClasses.items}`)
    let isMarketoForm = $select.closest('.mktoForm').length > 0

    $select.find('option, optgroup').each((index, option) => {
      let $option = $(option)
      let optionText = $option.text()

      if ($option.prop("tagName").toLowerCase() === 'option') {
        let optionVal = $(option).attr('value')

        if (optionVal === '-1' || optionText === '' || (optionVal === '' && isMarketoForm)) {
          return
        }

        $selectItems.append(`<div class="${selectorClasses.option}" data-value="${optionVal}">${optionText}</div>`)

        if ($option.is(':selected')) {
          $selectItems.find('div:last-child').addClass(selectorClasses.optionSelected)

          if (!isMultiple) {
            $selectSelected.html(optionText)
          }
        }
      } else {
        let optionLabel = $(option).attr('label')

        $selectItems.append(`<div class="${selectorClasses.optionGroup}">${optionLabel}</div>`)
      }
    })

    if ($select.attr('name') === 'Country') {
      $parentSelect.addClass(selectorClasses.country.main)
      $parentSelect.find(`.${selectorClasses.itemsWrapper}`).prepend(`<div class="${selectorClasses.country.inputWrapper}"><input type="text" class="${selectorClasses.country.input}" name="countrySearch" autocomplete="off"/></div>`)
    }
  }
}

/**
 * Événement input pour rechercher un pays
 *
 * @param e
 */
function handleKeydownSelector(e) {
  let $select = $(`.${selectorClasses.active}`)

  if ($select.length > 0) {
    let $selectItems = $select.find(`.${selectorClasses.items}`);

    if (e.keyCode === 27) { // Escape
      $(`.${selectorClasses.optionHover}`).removeClass(selectorClasses.optionHover)
      $select.removeClass(selectorClasses.active)
    }

    if (e.keyCode === 13) { // Enter
      e.preventDefault()
      let $optionSelected = $select.find(`.${selectorClasses.optionHover}:visible`)

      if ($optionSelected.length > 0) {
        $optionSelected.click()
      }
    }

    if (e.keyCode === 38) { // Up
      e.preventDefault()
      let $optionSelected = $select.find(`.${selectorClasses.optionHover}:visible`)

      if ($optionSelected.length > 0) {
        let $prevOption
        if ($optionSelected.is(':visible:first-child')) {
          $prevOption = $optionSelected.parent().find(`.${selectorClasses.option}:visible`).last()
        } else {
          $prevOption = $optionSelected.prevAll(':visible:first')
        }

        scrollToOption($selectItems, $prevOption)

        $optionSelected.removeClass(selectorClasses.optionHover)
        $prevOption.addClass(selectorClasses.optionHover)
      } else {
        $select.find(`.${selectorClasses.option}:visible`).first().addClass(selectorClasses.optionHover)
      }
    }

    if (e.keyCode === 40) { // Down
      e.preventDefault()
      let $optionSelected = $select.find(`.${selectorClasses.optionHover}`)

      if ($optionSelected.length > 0) {
        let $nextOption
        if ($optionSelected.is(':visible:last-child')) {
          $nextOption = $optionSelected.parent().find(`.${selectorClasses.option}`).first()
        } else {
          $nextOption = $optionSelected.nextAll(':visible:first')
        }

        scrollToOption($selectItems, $nextOption)

        $optionSelected.removeClass(selectorClasses.optionHover)
        $nextOption.addClass(selectorClasses.optionHover)
      } else {
        $select.find(`.${selectorClasses.option}:visible`).first().addClass(selectorClasses.optionHover)
      }
    }
  }
}

function scrollToOption($selectItems, $option) {
  let scrollTop = $selectItems.scrollTop() - $selectItems.offset().top + $option.offset().top - $option.outerHeight(true)

  $selectItems.animate({
    scrollTop: scrollTop > 0 ? scrollTop : 0
  }, 50)
}

/**
 * Événement input pour rechercher un pays
 *
 * @param e
 */
function handleInputCountry(e) {
  let $input = $(e.currentTarget)
  let inputValue = $input.val()
  let $select = $input.closest(`.${selectorClasses.main}`)
  let $items = $select.find(`.${selectorClasses.option}`)

  if (inputValue === '') {
    $items.removeClass('hide')
    return
  }

  $items.each((index, item) => {
    let $item = $(item)
    let itemText = $item.text()

    if (itemText.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) {
      $item.removeClass('hide')
    } else {
      $item.addClass('hide')
    }
  })
}

/**
 * Événement au clic sur le selector (ouvre/ferme le selector)
 *
 * @param e
 */
export function handleClickSelector(e) {
  e.preventDefault()

  if (hasCurrentFocusClickSelector) return

  hasCurrentFocusClickSelector = true

  let $element = $(e.currentTarget)
  let $select = $element.hasClass(selectorClasses.main) ? $element : $element.closest(`.${selectorClasses.main}`)

  if ($select.find('select').is(':disabled')) {
    hasCurrentFocusClickSelector = false
    return;
  }

  if ($select.hasClass(selectorClasses.active)) {
    closeSelector($select)
  } else {
    openSelector($select)
  }

  setTimeout(() => {
    hasCurrentFocusClickSelector = false
  }, 150)
}

/**
 * Événement au clic sur le document
 *
 * @param e
 */
function handleClickDocument(e) {
  let $element = $(e.target)
  let $selector = $element.closest(`.${selectorClasses.main}`)

  if ($selector.length === 0 && !$element.hasClass(`.${selectorClasses.main}`)) {
    $(`.${selectorClasses.main}`).not($selector).removeClass(selectorClasses.active)
    $(`.${selectorClasses.optionHover}`).removeClass(selectorClasses.optionHover)
  }
}

/**
 * Événement au clic sur une option du selector
 *
 * @param selectEvent
 */
export function handleClickSelectorOption(selectEvent) {
  let $currentItem = $(selectEvent.currentTarget)
  let $currentParent = $currentItem.closest(`.${selectorClasses.main}`)
  let $currentSelect = $currentParent.find('select')
  let $currentSelected = $currentParent.find(`.${selectorClasses.selected}`)
  let currentValue = $currentItem.data('value')
  let currentText = $currentItem.text()
  let isMultiple = $currentSelect.prop('multiple')

  if (isMultiple) {
    if ($currentItem.hasClass(selectorClasses.optionSelected)) {
      $currentItem.removeClass(selectorClasses.optionSelected)
      $currentParent.find('select option[value="' + currentValue + '"]').prop('selected', false)
    } else {
      $currentItem.addClass(selectorClasses.optionSelected)
      $currentParent.find('select option[value="' + currentValue + '"]').prop('selected', true)
    }
  } else {
    if ($currentItem.hasClass(selectorClasses.optionSelected)) {
      $currentItem.removeClass(selectorClasses.optionSelected)
      $currentParent.find(`select option[value="${currentValue}"]`).prop('selected', false)
      $currentSelected.html($currentSelect.find('option').first().text())
    } else {
      $currentParent.find(`.${selectorClasses.optionSelected}`).removeClass(selectorClasses.optionSelected)
      $currentItem.addClass(selectorClasses.optionSelected)
      $currentParent.find(`select option[value="${currentValue}"]`).prop('selected', true)
      $currentSelected.html(currentText)
    }
    $('body').click()
  }

  eventFire($currentSelect.get(0), 'change')
}

/**
 * Reset le selector à sa valeur par défaut
 *
 * @param $select
 */
export function resetSelector($select) {
  let $selectedOption = $select.find('option:selected')

  $select.addClass(selectorClasses.default)

  if ($selectedOption.length > 0) {
    let defaultOptionText = $select.find('option:first-child').text()

    $selectedOption.prop('selected', false)
    $select.find(`.${selectorClasses.selected}`).text(defaultOptionText)
    $select.find(`.${selectorClasses.optionSelected}`).removeClass(selectorClasses.optionSelected)
    $select.find(`.${selectorClasses.optionHover}`).removeClass(selectorClasses.optionHover)
  }
}

/**
 * Ouvre le selector
 *
 * @param $select
 */
export function openSelector($select) {
  $(`.${selectorClasses.main}`).removeClass(selectorClasses.active)
  $select.addClass(selectorClasses.active)

  if ($select.hasClass(selectorClasses.country.main)) {
    setTimeout(() => {
      let $input = $select.parent().find('input')
      let e = {
        currentTarget: $input[0]
      }
      $input.focus()
      handleInputCountry(e)
    }, 100)
  }
}

/**
 * Ferme le selector
 *
 * @param $select
 */
export function closeSelector($select) {
  $select.removeClass(selectorClasses.active)
  $select.parent().find(`.${selectorClasses.optionHover}`).removeClass(selectorClasses.optionHover)
}

/**
 *
 * @param el
 * @param type
 */
function eventFire(el, type) {
  if (typeof el !== 'undefined') {
    if (typeof el.fireEvent !== 'undefined') {
      el.fireEvent('on' + type)
    } else {
      let evObj = document.createEvent('Events')
      evObj.initEvent(type, true, false)
      el.dispatchEvent(evObj)
    }
  }
}
